import Alerts from "../util/Alerts";
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import React, { useEffect, useRef, useState } from "react";
import ReactTable from "react-table";
import { useSelector } from "react-redux";
import axios from "axios";
import { routes } from "../gen/General";
import { filterCaseInsensitive } from "../util/General";
import { ModalEliminarUsuario } from "../vam/modal/ModalEliminarUsuario";

export const VisorAll = () => {
    const alert = useRef(null);
    const user = useSelector(state => state.user);

    const [usuarios, setUsuarios] = useState({ list: [], loading: false });
    const [contractorsAndPolicyHoldersCount, setContractorsAndPolicyHoldersCount] = useState({
        total: 0,
        activeContractors: 0,
        activePolicyholders: 0,
        activeContractorsAndPolicyholders: 0,
    });

    useEffect(() => {
        getUsuariosVamGen();
    }, []);

    const getUsuariosVamGen = () => {
        if (!user.id) return;
        setUsuarios(prevState => ({ ...prevState, loading: true }));
        Promise.all([
            axios.get(routes.api + "/users-vam-gen"),
            axios.get(routes.api + "/users/contractors-policyholders-count"),
        ])
            .then(values => {
                setUsuarios(prevState => ({ ...prevState, list: values[0].data }));
                setContractorsAndPolicyHoldersCount(values[1].data);
            })
            .catch(alert.current.handleError)
            .finally(() => setUsuarios(prevState => ({ ...prevState, loading: false })));
    };

    const handleActivos = () => {
        const total = usuarios.list.filter(i => i.activo);
        return total.length;
    };

    const handleArray = props => {
        const array = props.value.split(",") || [];
        return (
            <div className={"d-flex flex-column"}>
                {array.map((i, idx) => (
                    <small key={idx}> {i}</small>
                ))}
            </div>
        );
    };

    const userStatistics = [
        {
            title: "# Total:",
            value: usuarios.list.length,
        },
        {
            title: "# Activos:",
            value: handleActivos(),
        },
        {
            title: "# Usuarios con contratantes activos:",
            value: contractorsAndPolicyHoldersCount.activeContractors,
        },
        {
            title: "# Usuarios con asegurados activos:",
            value: contractorsAndPolicyHoldersCount.activePolicyholders,
        },
        {
            title: "# Usuarios con contratantes y asegurados activos:",
            value: contractorsAndPolicyHoldersCount.activeContractorsAndPolicyholders,
        },
    ];

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-center" tag="h4">
                                Usuarios
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <Container>
                                <div className="row g-3 mb-1">
                                    {userStatistics.map(({ title, value }) => (
                                        <div key={title} className="col-md-4">
                                            <h6 className="text-primary">
                                                <b>{title} </b>
                                                {value}
                                            </h6>
                                        </div>
                                    ))}
                                </div>
                                <Row>
                                    <Col>
                                        <ReactTable
                                            noDataText={"No hay datos..."}
                                            loadingText={"Cargando..."}
                                            rowsText={"filas"}
                                            ofText={"de"}
                                            previousText={"Anterior"}
                                            nextText={"Siguiente"}
                                            pageText={"Página"}
                                            columns={[
                                                {
                                                    Header: "N.",
                                                    Cell: row => {
                                                        return <div>{row.index + 1}</div>;
                                                    },
                                                    width: 60,
                                                    hideFilter: true,
                                                    filterable: false,
                                                },
                                                {
                                                    Header: "CD Adicional",
                                                    accessor: "id",
                                                    filterable: false,
                                                    width: 100,
                                                },
                                                {
                                                    Header: "Correo",
                                                    accessor: "usuario",
                                                    filterable: true,
                                                },
                                                {
                                                    Header: "Activo",
                                                    accessor: "activo",
                                                    width: 85,
                                                    filterable: false,
                                                    Cell: row => {
                                                        return row.original.activo === true ? (
                                                            <p>
                                                                <span className={"badge badge-success"}>SI</span>
                                                            </p>
                                                        ) : (
                                                            <p>
                                                                <span className={"badge badge-danger"}>NO</span>
                                                            </p>
                                                        );
                                                    },
                                                },
                                                {
                                                    Header: "Contratante",
                                                    accessor: "apAsegurado",
                                                    filterable: false,
                                                    Cell: props => <>{handleArray(props)}</>,
                                                },
                                                {
                                                    Header: "Asegurado",
                                                    accessor: "nmAsegurado",
                                                    filterable: false,
                                                    Cell: props => <>{handleArray(props)}</>,
                                                },
                                                {
                                                    Header: "Boton",
                                                    accessor: "elmAsegurado",
                                                    filterable: false,
                                                    Cell: props => (
                                                        <ModalEliminarUsuario
                                                            id={props.original.id}
                                                            userAccount={props.original.usuario}
                                                            getUsuariosVamGen={getUsuariosVamGen}
                                                        />
                                                    ),
                                                },
                                            ]}
                                            data={usuarios.list}
                                            loading={usuarios.loading}
                                            pageSize={usuarios.list.length}
                                            showPaginationBottom={false}
                                            filterable
                                            defaultFilterMethod={filterCaseInsensitive}
                                            className="-striped -highlight"
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};
